import {createRouter, createWebHistory} from 'vue-router'
import { generateRoutes } from '@/extensions/langRouter'

import {QUERY_KEYS, ROUTES} from '@/helpers'

const Home = () => import('@/views/Home.vue')

const routes = [
	{
		path: '/',
		name: ROUTES.HOME,
		component: Home
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'catch-all',
		component: Home
	}
]

const localizedRoutes = generateRoutes(routes, 'en')

export default createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	linkActiveClass: '-active',
	linkExactActiveClass: '-exact-active',
	routes: localizedRoutes,
	scrollBehavior(to, from) {
		if(to.query[QUERY_KEYS['FORM']] || from.query[QUERY_KEYS['FORM']]) return

		if(to.hash) {
			return new Promise(resolve => setTimeout(() => resolve({el: to.hash, behavior: 'smooth'}), 450))
		}

		return { top: 0, behavior: 'smooth' }
	}
})